import React from "react";
import { GridList } from "material-ui";
import uniqueId from "lodash/uniqueId";

class ListGridList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      items: []
    };

    this.renderItem = this.renderItem.bind(this);
  }

  static get contextTypes() {
    return {
      isLarge: React.PropTypes.bool,
      isMedium: React.PropTypes.bool
    };
  }

  getStyles() {
    return {
      gridList: {}
    };
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    let final = [],
      { isLarge, isMedium } = this.context,
      colLimit = isLarge ? 3 : isMedium ? 2 : 1;

    newProps.items.forEach(item => {
      // Header-like items
      if (item.type) {
        final.push(item);

        // Grid list items
      } else if (final.length) {
        if (
          final[final.length - 1].type ||
          final[final.length - 1].length === colLimit
        ) {
          final.push([]);
        }
        final[final.length - 1].push(item);
      }
    });

    this.setState({ items: final });
  }

  renderItem(index, key) {
    let styles = this.getStyles(),
      { itemRenderer } = this.props,
      { isLarge, isMedium } = this.context,
      item = this.state.items[index];

    if (Array.isArray(item)) {
      return (
        <GridList
          key={key}
          cols={isLarge ? 3 : isMedium ? 2 : 1}
          cellHeight={250}
          style={styles.gridList}
        >
          {item.map(i => itemRenderer(i, uniqueId("gridList")))}
        </GridList>
      );
    } else {
      return itemRenderer(item, key);
    }
  }

  render() {
    let styles = this.getStyles(),
      { items } = this.state;

    return (
      <div>
        {this.state.items.map((_, i) =>
          this.renderItem(i, uniqueId("rootGridList"))
        )}
      </div>
    );
  }
}

export default ListGridList;



// WEBPACK FOOTER //
// ./src/app/components/partials/list/grid-list.jsx